<ng-container *ngFor="let pos of leftWindowPositions(); let rowIndex = index; trackBy: trackByIndex">
    <svg:g
        class="window-left"
        [style.animationDelay]="rowIndex * 0.01 + 's'">
        <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
            <path
                d="M14 14 L0 4 L0 18 L0 23 L14 33 Z"
                fill="var(--window-dark-bg-1)" />
            <path
                d="M14 14 L2 5.5 L2 18 L2 22 L14 31 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.a + ', ' + pos.b + ')'">
            <path
                d="M28 20 L0 3 L0 3 L0 25 L28 42 Z"
                fill="var(--window-lit-bg-2)" />

            @if (!rowIndex) {
                <path
                    d="M28 20 L35 16 L7 0 L0 4 L28 20 Z"
                    fill="var(--window-wall-bg)" />
            }

            <path
                d="M28 46 L35 41 L35 15 L28 21 Z"
                fill="var(--wall-bg-2)" />
            <path
                d="M28 45 L0 28 L0 25 L0 25 L28 42 Z"
                fill="#5182A2" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.c + ', ' + pos.d + ')'">
            <path
                d="M14 14 L0 4 L0 18 L0 23 L14 33 Z"
                fill="var(--window-dark-bg-1)" />
            <path
                d="M14 14 L2 5.5 L2 18 L2 22 L14 31 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>
    </svg:g>
</ng-container>

<ng-container *ngFor="let pos of rightWindowPositions(); let rowIndex = index; trackBy: trackByIndex">
    <svg:g
        class="window-left"
        [style.animationDelay]="rowIndex * 0.01 + 's'">
        <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
            <path
                d="M9.5 7.5 L0 13 L0 28 L0 30.5 L9.5 25 Z"
                fill="var(--window-dark-bg-1)" />
            <path
                d="M8.5 8.1 L0 13 L0 28 L0 29.5 L8.5 24.5 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>
        <svg:g [attr.transform]="'translate(' + pos.a + ', ' + pos.b + ')'">
            <path
                d="M9.5 8 L0 13 L0 28 L0 31 L9.5 25 Z"
                fill="var(--window-dark-bg-1)" />
            <path
                d="M8.5 8.5 L0 13 L0 28 L0 30 L8.5 24.5 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.c + ', ' + pos.d + ')'">
            <path
                d="M9.5 8 L0 13 L0 28 L0 31 L9.5 25 Z"
                fill="var(--window-dark-bg-1)" />
            <path
                d="M8.5 8.5 L0 13 L0 28 L0 30 L8.5 24.5 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>
    </svg:g>
</ng-container>
